import React from 'react';
import { Card, CardHeader, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import StatusChip from './StatusChip';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.RangeFinderCard.header.title',
        defaultMessage: 'Range finder',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.RangeFinderCard.header.subTitle',
        defaultMessage: 'Range finder reading',
    },
});
function RangeFinderCard({ realtimeMetrics, lastMetrics }) {
    const intl = useIntl();
    const rangeFinders = realtimeMetrics?.filter((e) => e.rangeFinder).map((e) => e.rangeFinder);
    const rangeFinder = rangeFinders && rangeFinders.length > 0 ? rangeFinders[rangeFinders.length - 1] : lastMetrics?.rangeFinder;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => !!e.rangeFinder }) }),
        React.createElement(CardContent, null, rangeFinder ? (React.createElement(TableContainer, { component: Paper, elevation: 0 },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { align: "right" }, "Distance"),
                        React.createElement(TableCell, { align: "right" }, "Voltage"))),
                React.createElement(TableBody, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { align: "right" }, rangeFinder && rangeFinder.distance ? `${rangeFinder.distance.toFixed(2)} m` : '-'),
                        React.createElement(TableCell, { align: "right" }, rangeFinder && rangeFinder.voltage ? `${rangeFinder.voltage.toFixed(2)} V` : '-')))))) : (React.createElement(Typography, { variant: "body2" }, "No data.")))));
}
export default React.memo(RangeFinderCard);
